// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Used to setup contain for fix-scroll */
#ischemeContainer {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.step-form .steps-container {
    min-height: 494px;
}

.modal__inner button{
    display: inline;
}

.modal__inner button.btn-cancel{
    background-color: #495061;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}

recaptcha {
    display: inline-block;
    margin: 0 auto 15px auto;
}

.loading-wrapper {
  background: #EBECEE;
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  transition: visibility 0.5s ease-in;
  visibility: hidden;
  width: 100vw;
  z-index: 9999;
}

  .loading-wrapper.active {
    display: block;
    visibility: visible;
  }

.loading {
    background-color: #495061;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 60px;
    right: 0;
    margin: auto;
    animation: sk-rotateplane 1.2s infinite ease-in-out;
  }
  
  @keyframes sk-rotateplane {
    0% { 
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg) 
    } 50% { 
      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg) 
    } 100% { 
      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
      -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    }
  }

.step-form .steps-container .form-section > div .alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}

.step-form .steps-container .form-section > div .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}

.step-form .steps-container .form-section > div .alert{
    width: 100%;
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/application.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,OAAO;EACP,eAAe;EACf,MAAM;EACN,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;EAEE;IACE,cAAc;IACd,mBAAmB;EACrB;;AAEF;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,QAAQ;IACR,YAAY;IAGZ,mDAAmD;EACrD;;EAQA;IACE;MACE,yDAAyD;MACzD;IACF,EAAE;MACA,8DAA8D;MAC9D;IACF,EAAE;MACA,iEAAiE;MACjE,yEAAyE;IAC3E;EACF;;AAEF;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":["/* Used to setup contain for fix-scroll */\r\n#ischemeContainer {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.step-form .steps-container {\r\n    min-height: 494px;\r\n}\r\n\r\n.modal__inner button{\r\n    display: inline;\r\n}\r\n\r\n.modal__inner button.btn-cancel{\r\n    background-color: #495061;\r\n}\r\n\r\nbutton:disabled {\r\n    cursor: not-allowed;\r\n    opacity: 0.4;\r\n    user-select: none;\r\n}\r\n\r\nrecaptcha {\r\n    display: inline-block;\r\n    margin: 0 auto 15px auto;\r\n}\r\n\r\n.loading-wrapper {\r\n  background: #EBECEE;\r\n  display: none;\r\n  height: 100vh;\r\n  left: 0;\r\n  position: fixed;\r\n  top: 0;\r\n  transition: visibility 0.5s ease-in;\r\n  visibility: hidden;\r\n  width: 100vw;\r\n  z-index: 9999;\r\n}\r\n\r\n  .loading-wrapper.active {\r\n    display: block;\r\n    visibility: visible;\r\n  }\r\n\r\n.loading {\r\n    background-color: #495061;\r\n    width: 60px;\r\n    height: 60px;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 60px;\r\n    right: 0;\r\n    margin: auto;\r\n    \r\n    -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;\r\n    animation: sk-rotateplane 1.2s infinite ease-in-out;\r\n  }\r\n  \r\n  @-webkit-keyframes sk-rotateplane {\r\n    0% { -webkit-transform: perspective(120px) }\r\n    50% { -webkit-transform: perspective(120px) rotateY(180deg) }\r\n    100% { -webkit-transform: perspective(120px) rotateY(180deg)  rotateX(180deg) }\r\n  }\r\n  \r\n  @keyframes sk-rotateplane {\r\n    0% { \r\n      transform: perspective(120px) rotateX(0deg) rotateY(0deg);\r\n      -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg) \r\n    } 50% { \r\n      transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);\r\n      -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg) \r\n    } 100% { \r\n      transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\r\n      -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);\r\n    }\r\n  }\r\n\r\n.step-form .steps-container .form-section > div .alert-success {\r\n    color: #155724;\r\n    background-color: #d4edda;\r\n    border-color: #c3e6cb;\r\n}\r\n\r\n.step-form .steps-container .form-section > div .alert-danger {\r\n    color: #721c24;\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n}\r\n\r\n.step-form .steps-container .form-section > div .alert{\r\n    width: 100%;\r\n    position: relative;\r\n    padding: .75rem 1.25rem;\r\n    margin-bottom: 1rem;\r\n    border: 1px solid transparent;\r\n    border-radius: .25rem;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
